// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Projects_Projects__5\\+mCu .Projects_content__q5NVk {
  padding: 2.5rem;
  margin-bottom: 5vh;
}
.Projects_Projects__5\\+mCu .Projects_projectsContainer__D6Nqc {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 8vh;
}
.Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_projectTitle__pQb1Q {
  text-decoration: underline;
  font-size: 1.8rem;
}
@media only screen and (max-width: 768px) {
  .Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_projectTitle__pQb1Q {
    font-size: 1.2rem;
  }
}
.Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_textSection__WQgSH {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  font-size: 1.2rem;
  text-align: center;
  white-space: pre-line;
}
@media only screen and (max-width: 768px) {
  .Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_textSection__WQgSH {
    font-size: 1rem;
  }
}
.Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_textSection__WQgSH {
  padding: 2.5rem;
}
.Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_skillSection__nysAP {
  display: inherit;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_skillSection__nysAP .Projects_skillContainer__CkqhF {
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
.Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_linkSection__TbB\\+A {
  display: inherit;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Projects_Projects__5\\+mCu .Projects_projectContent__pMWdi .Projects_linkSection__TbB\\+A .Projects_linkContainer__agqO9 {
  border-radius: 1rem;
  display: flex;
  flex-direction: row;
}
.Projects_Projects__5\\+mCu .Projects_darkTheme__Fw2hy {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-radius: 1rem;
}
.Projects_Projects__5\\+mCu .Projects_lightTheme__MW9Ru {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-radius: 1rem;
}
.Projects_Projects__5\\+mCu .Projects_colorfulTheme__pbmdo {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/views/Projects/Projects.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAUE;EACE,eCPgC;EDQhC,kBAAA;AATJ;AAYE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,WAAA;EApBA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBCJiB;EDuBjB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AARJ;AASI;EACE,0BAAA;EACA,iBAAA;AAPN;AAQM;EAHF;IAII,iBClCS;ED6Bf;AACF;AAOI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,iBC1CW;ED2CX,kBAAA;EACA,qBAAA;AALN;AAMM;EARF;IASI,eAAA;EAHN;AACF;AAPI;EAWE,eC7C8B;AD4CpC;AAGI;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAIM;EACE,mBCxDa;EDyDb,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAFR;AAOI;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AALN;AAQM;EAKE,mBC9Ea;ED+Eb,aAAA;EACA,mBAAA;AAVR;AAgBE;EChCA,gBAAA;EACA,sBAAA;EACA,2CAnD4B;EDJ1B,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBCJiB;AD+ErB;AAYE;EC/BA,gBAAA;EACA,sBAAA;EACA,0CAxD6B;EDL3B,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBCJiB;ADwFrB;AAQE;EC9BA,gBAAA;EACA,sBAAA;EACA,0CA9D6B;EDL3B,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBCJiB;ADiGrB","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.Projects {\n  @mixin contentStyling {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    border-radius: $globalBorderRadius;\n  }\n\n  .content {\n    padding: $globalHomeContentContainerPadding;\n    margin-bottom: 5vh;\n  }\n\n  .projectsContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .projectContent {\n    width: 100%;\n    @include contentStyling;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 8vh;\n    .projectTitle {\n      text-decoration: underline;\n      font-size: $globalFontSize * 1.5;\n      @media only screen and (max-width: 768px) {\n        font-size: $globalFontSize;\n      }\n    }\n    .textSection {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 70%;\n      font-size: $globalFontSize;\n      text-align: center;\n      white-space: pre-line;\n      @media only screen and (max-width: 768px) {\n        font-size: 1rem;\n      }\n      padding: $globalHomeContentContainerPadding;\n    }\n    .skillSection {\n      display: inherit;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      .skillSectionHeader {\n      }\n      .skillContainer {\n        border-radius: $globalBorderRadius;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: row;\n        flex-wrap: wrap;\n        //transform: scale(0.8);\n      }\n    }\n\n    .linkSection {\n      display: inherit;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      .linkSectionHeader {\n      }\n      .linkContainer {\n        &:hover {\n          // --pulse-color: #ff6f69;\n          // @include globalPulseAnimationMixin;\n        }\n        border-radius: $globalBorderRadius;\n        display: flex;\n        flex-direction: row;\n        //transform: scale(0.8);\n      }\n    }\n  }\n\n  .darkTheme {\n    @include darkThemeContent;\n    @include contentStyling;\n  }\n\n  .lightTheme {\n    @include lightThemeContent;\n    @include contentStyling;\n  }\n\n  .colorfulTheme {\n    @include colorfulThemeContent;\n    @include contentStyling;\n  }\n}\n","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Projects": `Projects_Projects__5+mCu`,
	"content": `Projects_content__q5NVk`,
	"projectsContainer": `Projects_projectsContainer__D6Nqc`,
	"projectContent": `Projects_projectContent__pMWdi`,
	"projectTitle": `Projects_projectTitle__pQb1Q`,
	"textSection": `Projects_textSection__WQgSH`,
	"skillSection": `Projects_skillSection__nysAP`,
	"skillContainer": `Projects_skillContainer__CkqhF`,
	"linkSection": `Projects_linkSection__TbB+A`,
	"linkContainer": `Projects_linkContainer__agqO9`,
	"darkTheme": `Projects_darkTheme__Fw2hy`,
	"lightTheme": `Projects_lightTheme__MW9Ru`,
	"colorfulTheme": `Projects_colorfulTheme__pbmdo`
};
export default ___CSS_LOADER_EXPORT___;
